import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import Product from "./Product";
import ProductSkelton from "./ProductSkelton";

import { productsItems } from "../../apis/productsApiSlice";

const BestSelling = () => {
  const products = useSelector(productsItems);

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 3000);
  }, []);

  if (products?.length) {
    const filteredProducts = products.filter(
      (product) => product?.rating?.count > 350
    );

    const starRatings = (rating) => {
      const rateElements = [];
      const rate = Math.round(rating);

      for (let i = 1; i < 6; i++) {
        rateElements.push(
          <span key={i}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill={i < rate ? "#000" : "none"}
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z"
              ></path>
            </svg>
          </span>
        );
      }

      return rateElements;
    };
    return (
      <section className="mt-[50px] sm:mt-[100px]">
        <div className="text-center mb-8">
          <span className="mb-2 mx-auto">Store</span>
          <h3 className="text-4xl">Best Selling</h3>
        </div>
        <div className="flex flex-wrap gap-8">
          {filteredProducts?.length > 0 &&
            filteredProducts.map(
              (product, index) =>
                index < 4 &&
                (isLoading ? (
                  <ProductSkelton key={index} />
                ) : (
                  <Product product={product} key={index} />
                ))
            )}
        </div>
      </section>
    );
  }
};

export default BestSelling;
